import React, { useEffect } from 'react'
import RepaymentSchedule from '../../../components/RepaymentSchedule/RepaymentSchedule'
import { useDispatch, useSelector } from 'react-redux'
import { getRepaymentSchedule } from '../../../redux/TrancheReducer/action';
import { useParams } from 'react-router-dom';

const ActiveTrancheDetails = () => {
  let { trancheId } = useParams();

  const { repaymentSchedule, loading, singleTranche } = useSelector((store) => {
      return {
        loading: store.TrancheReducer.loading,
        repaymentSchedule: store.TrancheReducer.repaymentSchedule,
        singleTranche: store.TrancheReducer.singleTranche
      }
  });

  const dispatch = useDispatch();

  console.log({ trancheId });

  useEffect(() => {
    if(trancheId){
      dispatch(getRepaymentSchedule(trancheId));
    }
  }, [dispatch, trancheId]);

  console.log({ repaymentSchedule })

  if (loading || !singleTranche || String(singleTranche?.tranche_id) !== String(trancheId)) {
    return <div style={{ padding: '30px', textAlign: 'center', color: '#64748b' }}>Loading tranche details...</div>;
  }

  return (
    <div>
      <RepaymentSchedule repaymentSchedule={repaymentSchedule} tranche={singleTranche} />
    </div>
  )
}

export default ActiveTrancheDetails